import request from '@/utils/request'

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get',
    timeout: 20000
  })
}
// 登录方法
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}
// 忘记密码改密方法
export function updatePwd(data) {
  return request({
    url: '/system/user/profile/updatePassword',
    method: 'post',
    data
  })
}
// 重置改密方法
export function updatePassword(data) {
  return request({
    url: '/system/user/profile/resetPassword',
    method: 'post',
    data
  })
}
// 注册方法
export function register(data) {
  return request({
    url: '/register',
    method: 'post',
    data
  })
}
// 重复信息校验 401
export function repeat(data) {
  return request({
    url: '/valid/repeat',
    method: 'post',
    data
  })
}
// 自动登录方法
export function autoLogin(data) {
  return request({
    url: '/single/sign/on/login',
    method: 'post',
    data
  })
}

// 发送短信
export function sendMsg(data) {
  return request({
    url: '/smsSend/smsValidCode',
    method: 'post',
    data
  })
}
// 发送短信
export function sendSmsByUserName(data) {
  return request({
    url: '/smsSend/sendSmsByUserName',
    method: 'post',
    data
  })
}
// 注册方法
export function registerPerson(data) {
  return request({
    url: '/registerPerson',
    method: 'post',
    data
  })
}

// 获取养老机构系统链接
export function getCareLink() {
  return request({
    url: '/system/user/getJumpUrl',
    method: 'get',
    timeout: 20000
  })
}

// 查询token是否过期
export function validToken(token) {
  return request({
    url: '/token/valid/' + parseStrEmpty(token),
    method: 'get'
  })
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
  if (!str || str == "undefined" || str == "null") {
    return "";
  }
  return str;
}

// 判断是否登录
export function isLogin() {
  return request({
    url: '/index/get/loginFlag',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js